import styled from 'styled-components';

export const Columns = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;

  & > div {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
`;
